export const recordsEqual = (
  obj1: Record<number, string>,
  obj2: Record<number, string>,
): boolean => {
  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  if (keys1.length !== keys2.length) return false;

  return keys1.every(key => key in obj2 && obj1[key] === obj2[key]);
};
